/**
 * Center Panel Component
 *
 * Character display area with:
 * - TOKCHAN Logo
 * - Progress Bar (Like Gauge)
 * - BGM Info Display
 * - Background Video
 * - Character (Body, Eyes, Mouth)
 */

import React, { useState, useEffect, useCallback } from 'react';
import { TokchanCharacter } from '../character/TokchanCharacter.js';
import { ProgressBar } from '../character/ProgressBar.js';
import { BGMInfoDisplay } from '../character/BGMInfoDisplay.js';
import { useTokchanStore } from '@/store/tokchanStore.js';
import './CenterPanel.css';

export const CenterPanel: React.FC = () => {
    const [progress, setProgress] = useState(0);
    const [showRainbow, setShowRainbow] = useState(false);

    // プログレスバー更新関数
    const setCenterProgress = useCallback((value: number) => {
        setProgress(Math.min(100, Math.max(0, value)));
        // 100%到達時はレインボーエフェクト
        if (value >= 100) {
            setShowRainbow(true);
        }
    }, []);

    // リセット関数
    const resetCenterProgress = useCallback(() => {
        setProgress(0);
        setShowRainbow(false);
    }, []);

    // グローバルAPI登録（Zustand store優先）
    useEffect(() => {
        const api = {
            setProgress: setCenterProgress,
            reset: resetCenterProgress
        };

        // Zustand storeに登録
        useTokchanStore.getState().setCenterProgress(api);
        // 後方互換性のためwindowにも登録
        window.setCenterProgress = setCenterProgress;
        window.resetCenterProgress = resetCenterProgress;

        return () => {
            useTokchanStore.getState().setCenterProgress(null);
            delete window.setCenterProgress;
            delete window.resetCenterProgress;
        };
    }, [setCenterProgress, resetCenterProgress]);

    return (
        <div className="center-panel character-only-panel">
            {/* TOKCHAN Logo */}
            <div className="tokchan-logo">
                <img src="/assets/UI/logo_white.png" alt="TOKCHAN" />
            </div>

            {/* Icon Image */}
            <div className="icon-overlay">
                <img src="/assets/UI/img_icon.png" alt="Icon" />
            </div>

            {/* BGM Info Display */}
            <BGMInfoDisplay />

            {/* Progress Bar */}
            <ProgressBar progress={progress} showRainbow={showRainbow} />

            {/* Background Video */}
            <video
                id="background-video"
                className="background-video"
                muted
                playsInline
            />

            {/* Character Display */}
            <TokchanCharacter />
        </div>
    );
};

export default CenterPanel;
